module.exports = __webpack_public_path__ + "files/f2daa4cd3824ce25512c4a5cd75665bb.png";